import { IFilter } from '@/shared';
import { CvSkillSearchParams } from '@/types/cv';

export const cvQueryKeys = {
  myCv: ['my-cv'] as const,
  cvCompanies: ['cv-companies'] as const,
  cvPositions: ['cv-positions'] as const,
  cvSchools: ['cv-schools'] as const,
  cvSkills: (params: CvSkillSearchParams) =>
    ['cv-skills', { ...params }] as const,
  cvReviewers: {
    all: ['cv-reviewers'] as const,
    list: (filters: IFilter) =>
      [...cvQueryKeys.cvReviewers.all, 'list', filters] as const,
  },
  jobOffers: {
    all: ['job-offers'] as const,
    list: (filters: IFilter) =>
      [...cvQueryKeys.jobOffers.all, 'list', filters] as const,
  },
} as const;
